import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

// export const fetchDeliveryDate = createAsyncThunk(
//     'checkout/fetchDeliveryDate',
//     async (userId, { rejectWithValue }) => {
//         try {
//             const { data } = await axiosInstance.post(`/checkout/delivery-date`, {
//                 user_id: userId,
//             });
           
//             return data;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data?.message || 'Failed to fetch delivery dates',
//             );
//         }
//     },
// );

export const applyPromoCode = createAsyncThunk(
    'checkout/applyPromoCode',
    async (payload, { rejectWithValue }) => {
        try {
            if (localStorage.getItem('isMobileApp') === 'true') {
                payload = { ...payload, platform_type: 'mobile' };
            } else {
                payload = { ...payload, platform_type: 'web' };
            }
            const { data } = await axiosInstance.post(`/checkout/apply-promo-code`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to apply promo code');
        }
    },
);

// Remove promo code
export const removePromoCode = createAsyncThunk(
    'checkout/removePromoCode',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/checkout/remove-promo-code`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to remove promo code');
        }
    },
);
// Create Payment
export const createPayment = createAsyncThunk(
    'checkout/createPayment',
    async (payload, { rejectWithValue }) => {
        try {
            if (localStorage.getItem('isMobileApp') === 'true') {
                payload = { ...payload, platform_type: 'mobile' };
            } else {
                payload = { ...payload, platform_type: 'web' };
            }
            const { data } = await axiosInstance.post(`/checkout/place-order`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to create do direct payment.');
        }
    },
);

// Manage Reward Points
export const manageRewardPoints = createAsyncThunk(
    'checkout/manageRewardPoints',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/checkout/reward-points`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to Create Reward Points.');
        }
    },
);

// Get Reward Points
export const getRewardPoints = createAsyncThunk(
    'rewards/getRewardPoints',
    async (userId, { rejectWithValue }) => {
        try {
            // Using GET request with userId as URL parameter
            const { data } = await axiosInstance.get(`/checkout/reward-points`);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch reward points.',
            );
        }
    },
);

// Get Rewards History
export const getUserRewardHistory = createAsyncThunk(
    'rewards/getUserRewardHistory',
    async (_,{ rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/checkout/rewards-history`);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch reward history.',
            );
        }
    },
);

// PayPal Payment Completion
export const completePayPalPayment = createAsyncThunk(
    'checkout/completePayPalPayment',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/checkout/paypal/completed`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to complete PayPal payment.',
            );
        }
    },
);

// Fetch Zelle Payments (for Zelle Credit payment method)
export const fetchZellePayments = createAsyncThunk(
    'checkout/fetchZellePayments',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/checkout/zelle-payments`);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch Zelle payments.');
        }
    },
);

// Pay Now for Cash Orders
export const payNow = createAsyncThunk(
    'checkout/payNow',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/checkout/pay-now`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to initiate payment.',
            );
        }
    },
);